<template>
  <div id="batch">  
    <div v-for="shipment of shipments.slice().reverse()" v-bind:key="shipment['.key']">
      <div v-if="shipment['.key']==id">
        <h4>Shipment ID: {{shipment.id}}</h4>
      </div>
    </div>
    <div id="shipmentsTable" class="noselect">
      <div>
        <ul class="tableHead text-center">
          <li>
            <b-row>
              <b-col cols="1">ID</b-col>
              <b-col>Species </b-col>
              <b-col>Good </b-col>
              <b-col>Poor </b-col>
              <b-col>No Emergence </b-col>
              <b-col>Diseased </b-col>
              <b-col>Parasites</b-col>
              <b-col>Emerged in transit</b-col>
              <b-col>Damaged in transit</b-col>
              <b-col>Released</b-col>
              <b-col></b-col>
            </b-row>
          </li>
        </ul>
        <ul>
          <li class="formInputs"><b-row class="text-center">
            <b-col cols="1"></b-col>
            <b-col> 
              <b-form-select v-model="speciesN">
                <b-form-select-option v-for="butterfly of butterflies.filter(thisUser).slice().reverse()" v-bind:key="butterfly['.key']" :value="butterfly.scientificName">{{butterfly.scientificName}}</b-form-select-option>            
              </b-form-select>
            </b-col>
            <b-col><b-form-input type="text" v-model="good" id="good" onfocus="this.value=''"></b-form-input></b-col>
            <b-col><b-form-input type="text" v-model="poor" id="poor" onfocus="this.value=''"></b-form-input></b-col>
            <b-col><b-form-input type="text" v-model="noEmergence" id="no" onfocus="this.value=''"></b-form-input></b-col>
            <b-col><b-form-input type="text" v-model="diseased" id="diseased" onfocus="this.value=''"></b-form-input></b-col>
            <b-col><b-form-input type="text" v-model="parasites" id="parasites" onfocus="this.value=''"></b-form-input></b-col>
            <b-col><b-form-input type="text" v-model="emerged" id="emerged" onfocus="this.value=''"></b-form-input></b-col>
            <b-col><b-form-input type="text" v-model="damaged" id="damaged" onfocus="this.value=''"></b-form-input></b-col>
            <b-col><b-form-input type="text" v-model="released" id="released" onfocus="this.value=''"></b-form-input></b-col>
            <b-col><b-button @click="add()" style="width: 100px" ><b-icon-plus></b-icon-plus></b-button></b-col>
          </b-row></li>
        </ul>
        <datalist id="supplierList">
          <option>LPS</option>
          <option>TEH</option>
          <option>GC</option>
          <option>EBN</option>
          <option>SUA</option>
          <option>CRES</option>
        </datalist>

        <datalist id="speciesNames">
          <div v-for="butterfly of butterflies.slice().reverse()" v-bind:key="butterfly['.key']">
            <option>{{butterfly.scientificName}}</option>
          </div>
        </datalist>

      </div>
      <div>
        <div class="tableBody" >
          <div v-for="batch of batches.filter(thisUser).slice().reverse()" v-bind:key="batch['.key']">
            <ul v-if="batch.id == id">
              <li class="tableElement"  >
                <div v-if="!batch.edit && batch.id == id">
                  <b-row class="text-center">
                    <b-col cols="1">{{batch.counter}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.speciesN}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.good}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.poor}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.noEmergence}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.diseased}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.parasites}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.emerged}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.damaged}}</b-col>
                    <b-col @click="toEmergence(batch['.key'])">{{batch.released}}</b-col>
                    <b-col>
                      <b-button-group>
                        <b-button variant="outline-primary" @click="edit(batch, batch['.key'])"><b-icon-pencil></b-icon-pencil></b-button>
                        <b-button variant="danger" @click="remove(batch, batch['.key'])"><b-icon-trash></b-icon-trash></b-button>
                      </b-button-group>
                    </b-col>
                  </b-row>
                </div>
                <div v-else-if="batch.edit && batch.id == id">
                  <b-row class="text-center">
                    <b-col cols="1">{{batch.counter}}</b-col>
                    <b-col><b-form-select type="text" v-model="batch.speciesN">
                      <b-form-select-option v-for="butterfly of butterflies.slice().reverse()" v-bind:key="butterfly['.key']" :value="butterfly.scientificName">{{butterfly.scientificName}}</b-form-select-option>
                    </b-form-select></b-col>
                    <b-col><b-form-input type="text" v-model="batch.good"></b-form-input></b-col>
                    <b-col><b-form-input type="text" v-model="batch.poor"></b-form-input></b-col>
                    <b-col><b-form-input type="text" v-model="batch.noEmergence"></b-form-input></b-col>
                    <b-col><b-form-input type="text" v-model="batch.diseased"></b-form-input></b-col>
                    <b-col><b-form-input type="text" v-model="batch.parasites"></b-form-input></b-col>
                    <b-col><b-form-input type="text" v-model="batch.emerged"></b-form-input></b-col>
                    <b-col><b-form-input type="text" v-model="batch.damaged"></b-form-input></b-col>
                    <b-col><b-form-input type="text" v-model="batch.released"></b-form-input></b-col>
                    <b-col>
                      <b-button-group>
                        <b-button @click="save(batch)"><b-icon-check></b-icon-check></b-button>
                        <b-button variant="danger" @click="cancel(batch['.key'])"><b-icon-x></b-icon-x></b-button>
                      </b-button-group>
                    </b-col>
                  </b-row>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="text-center"><h3 id="indicator"></h3></div>
      </div></div>
      <div id="snackbar">{{toastMessage}}</div>
    </div>
  </template>

  <style>
  #batch {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    padding: 10px 50px 50px 50px;
  }

  .tableHead{
    background-color: #343a40;
    color: white;
    display: block;
  }

  .tableBody {
    display:block;
  }

  .batchTable{
    background-color: red;
  }


  .tableElement{
    padding: 10px 10px 10px 10px;
    z-index: -1;
    color:black;
    cursor: pointer;
  }

  .floatAbove{
    z-index: 2;
  }

  .formInputs{
    padding: 10px 10px 10px 10px;
  }

  .tableElement:hover{
    background-color: grey;
    padding: 10px 10px 10px 10px; 
    color:white;

  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    margin: 10px 10px;
  }

  a {
    color: #42b983;
  }

  #snackbar {
    visibility: hidden; /* Hidden by default. Visible on click */
    min-width: 250px; /* Set a default minimum width */
    margin-left: -125px; /* Divide value of min-width by 2 */
    background-color: #333; /* Black background color */
    color: #fff; /* White text color */
    text-align: center; /* Centered text */
    border-radius: 2px; /* Rounded borders */
    padding: 16px; /* Padding */
    position: fixed; /* Sit on top of the screen */
    z-index: 1; /* Add a z-index if needed */
    left: 45%; /* Center the snackbar */
    bottom: 30px; /* 30px from the bottom */
  }


  #snackbar.show {
    visibility: visible; 
    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
    animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }

  /* Animations to fade the snackbar in and out */
  @-webkit-keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }

  @keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }

  @-webkit-keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }

  @keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }

  </style>

  <script>
  import { shipmentsRef } from '../firebase'
  import { batchRef } from '../firebase'
  import { butterflyRef } from '../firebase'
  export default {
    name: 'batch',
    data () {
      return {
        shipments: [],
        batches: [],
        butterflies: [],
        toastMessage: '',
        id: '',
        speciesN: '',
        good: '',
        poor: '',
        noEmergence: '',
        diseased: '',
        parasites: '',
        emerged: '',
        damaged: '',
        released: '',
        speciesArr: [],
        safe: null,
      }
    },
    firebase: {
      shipments: shipmentsRef,
      batches: batchRef,
      butterflies: butterflyRef,
    },
    created() {  
      this.id = this.$route.params.id;
    },
    methods: {
      add() {
        if(this.speciesN === '' || this.good === '' || this.poor === '' || this.diseased === '' || this.parasites === '' || this.noEmergence === '' || this.emerged === '' || this.damaged === '' || this.released === ''){
          this.showSnackBar('Please fill out all fields');
          return;
        }

        if(isNaN(this.good) || isNaN(this.poor) || isNaN(this.diseased) || isNaN(this.parasites) || isNaN(this.noEmergence) 
          || isNaN(this.emerged) || isNaN(this.damaged) || isNaN(this.released)){
          this.showSnackBar('Good, Poor, Diseased, Parasites, No Emergence, Emerged, Damaged and Released should be numbers');
        return;
      }

      if(this.good<0 || this.poor<0 || this.diseased<0 || this.parasites<0 || this.noEmergence<0 || this.emerged<0
        || this.damaged<0 || this.released<0){
        this.showSnackBar('Good, Poor, Diseased, Parasites, Emerged, Damaged and Released cannot be less than 0');
      return;
    }

    var currentShipment = null;
    for(let i =0; i<this.shipments.length; i++){
      if(this.shipments[i]['.key']==this.id){
        currentShipment = this.shipments[i];
      }
    }


    var additions = parseInt(this.good) + parseInt(this.poor) + parseInt(this.noEmergence) + parseInt(this.diseased) + parseInt(this.parasites) + parseInt(this.emerged) + parseInt(this.damaged) + parseInt(this.released);


    if(parseInt(currentShipment.numberReceived) - parseInt(currentShipment.accountedFor) - parseInt(additions) < 0){
      this.showSnackBar('Total emergences cannot exceed number received');
      return;
    }else{
      shipmentsRef.child(this.id).update({accountedFor:parseInt(currentShipment.accountedFor)+parseInt(additions)});
    }

    var commonName = '';
    for(let i =0; i<this.butterflies.length; i++){
      if(this.butterflies[i].scientificName==this.speciesN){
        commonName = this.butterflies[i].commonName;
        break;
      }
    }

    if(this.batches.length == 0){
      batchRef.push({counter: 1, speciesN: this.speciesN, good: this.good, poor: this.poor, noEmergence: this.noEmergence,
        diseased: this.diseased, parasites: this.parasites, emerged: this.emerged, damaged: this.damaged, released: this.released, edit:false, id: this.id, commonName: commonName, user: this.getUser() });
    }else{
      batchRef.push({counter: this.batches[this.batches.length-1].counter+1, speciesN: this.speciesN, good: this.good, poor: this.poor, noEmergence: this.noEmergence,
        diseased: this.diseased, parasites: this.parasites, emerged: this.emerged, damaged: this.damaged, released: this.released, edit:false, id: this.id, commonName: commonName, user: this.getUser() });
    }
    this.showSnackBar('Batch Added');
  },
  remove(batch, key) {

    var removals = parseInt(batch.good)+parseInt(batch.poor)+parseInt(batch.noEmergence)+parseInt(batch.diseased)+parseInt(batch.parasites)+parseInt(batch.emerged)+parseInt(batch.damaged)+parseInt(batch.released);

    var currentShipment = null;
    for(let i =0; i<this.shipments.length; i++){
      if(this.shipments[i]['.key']==this.id){
        currentShipment = this.shipments[i];
      }
    }

    shipmentsRef.child(this.id).update({accountedFor: parseInt(currentShipment.accountedFor)-parseInt(removals)});

    batchRef.child(key).remove();
    this.showSnackBar('Batch Removed');
  },
  edit(batch, key){
    batchRef.child(key).update({edit: true});
    this.safe = parseInt(batch.good) + parseInt(batch.poor) + parseInt(batch.noEmergence) + parseInt(batch.diseased) + parseInt(batch.parasites)+ parseInt(batch.emerged)+ parseInt(batch.damaged)+ parseInt(batch.released);
  },
  cancel(key){
    batchRef.child(key).update({edit: false});
  },
  save(batch){
    if(batch.speciesN === '' || batch.good === '' || batch.poor === ''
      || batch.diseased === '' || batch.parasites ===''  || batch.noEmergence === '' || batch.emerged === '' 
      || batch.damaged === '' || batch.released === ''){
      this.showSnackBar('Please fill out all fields');
    return;
  }

  if(isNaN(batch.good) || isNaN(batch.poor) || isNaN(batch.diseased) || isNaN(batch.parasites) || isNaN(batch.noEmergence)
    || isNaN(batch.emerged) || isNaN(batch.damaged) || isNaN(batch.released)){
    this.showSnackBar('Good, Poor, Diseased, Parasites, No Emergence, Emerged, Damaged and Released should be numbers');
  return;
}

if(batch.good<0 || batch.poor<0 || batch.diseased<0 || batch.parasites<0 || batch.noEmergence<0 || batch.emerged<0
  || batch.damaged<0 || batch.released<0){
  this.showSnackBar('Good, Poor, Diseased, Parasites, Emerged, Damaged and Released cannot be less than 0');
return;
}

var currentShipment = null;
for(let i =0; i<this.shipments.length; i++){
  if(this.shipments[i]['.key']==this.id){
    currentShipment = this.shipments[i];
  }
}



var additions = parseInt(batch.good) + parseInt(batch.poor) + parseInt(batch.noEmergence) + parseInt(batch.diseased) + parseInt(batch.parasites) + parseInt(batch.emerged)+ parseInt(batch.damaged) + parseInt(batch.released);
var compute = 0;
if(this.safe === null){
  compute = 0;
}else{
  compute = additions - this.safe;
}
if(parseInt(currentShipment.numberReceived) - parseInt(currentShipment.accountedFor) - parseInt(compute) < 0){
  this.showSnackBar('Total emergences cannot exceed number received');
  return;
}else{
  shipmentsRef.child(this.id).update({accountedFor: parseInt(currentShipment.accountedFor)+parseInt(compute)});
}

var commonName = '';
for(let i =0; i<this.butterflies.length; i++){
  if(this.butterflies[i].scientificName==batch.speciesN){
    commonName = this.butterflies[i].commonName;
    console.log(commonName);
    break;
  }
}

const key = batch['.key'];
batchRef.child(key).update({speciesN: batch.speciesN, good: batch.good, poor: batch.poor, noEmergence: batch.noEmergence, diseased: batch.diseased, parasites: batch.parasites, emerged: batch.emerged, damaged: batch.damaged, 
  released: batch.released, edit:false, commonName: commonName});
this.showSnackBar('Batch Updated');
},
showSnackBar(message){
  this.toastMessage = message;
  var x = document.getElementById("snackbar");
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
},
goShipments(){
  this.$router.push('/shipments');
},
toEmergence(key){
  this.$router.push({name:'Batch', params: {id: this.id, id2: key }})
},
getUser(){
  return this.$parent.activeUser?this.$parent.activeUser.name:'';
},
thisUser(butterfly){
  return (butterfly.user == this.getUser() || this.getUser() == 'Reiman Gardens')?butterfly:null
}
}
}
</script>
}

